import { module } from 'constant'
import { createSelector } from 'selectors'

const { passwordManager } = module

const getPasswordGeneratorForm = () => createSelector<HTMLElement>({ selector: passwordManager.selectors.form })

const getGeneratePasswordButtonSelector = (scope?: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: passwordManager.selectors.generateButton })

const getPasswordInputsSelector = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: passwordManager.selectors.passwordInput }, true)

const getPasswordLabelSelector = (scope?: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: passwordManager.selectors.generatedPasswordLabel })

const getPasswordMinimalLengthSelector = (scope?: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: passwordManager.selectors.minimalPasswordLength })

export const getPasswordGeneratorFormSelectors = () => {
	const scope = getPasswordGeneratorForm()
	if (!scope) {
		return null
	}

	return {
		generateButton: getGeneratePasswordButtonSelector(scope),
		passwordInputs: getPasswordInputsSelector(scope),
		passwordLabel: getPasswordLabelSelector(scope),
		minimalPasswordLength: getPasswordMinimalLengthSelector(scope),
	}
}
